import type { IFormStage } from './FormStage.helpers';

const FormStage = ({ children, hide, className }: IFormStage) => {
	if (hide) return <></>;

	return (
		<div
			data-testid='modal-stage'
			className={className}
		>
			{children}
		</div>
	);
};

export default FormStage;
